import React from 'react';

import Swiper from '@travel/traveler-core/components/Swiper';
import { GalleryIcon } from '@travel/ui';
import type { GalleryMedia } from '@travel/ui/components/Gallery';

import Media from '../../../../components/Media';

import styles from './roomPlanGalleryCover.module.scss';

type Props = {
  isFirst: boolean;
  medias: GalleryMedia[];
  onOpenDetail(): void;
};

function MobileView({ isFirst, medias, onOpenDetail }: Props) {
  return (
    <div className={styles.swiperWrapper}>
      <Swiper
        className={styles.swiper}
        paginationType="swipe"
        shouldUpdateOnceVisible={true}
        shouldNotSwipe={false}
        shouldRenderAllChild={false}
      >
        {medias.map((media, i) => (
          <Media
            className={styles.swiperMedia}
            key={`${media.url}${i}`}
            media={media}
            sizes="100vw"
            onClick={onOpenDetail}
            isDisableLazyload={isFirst && i === 0}
          />
        ))}
      </Swiper>
      <GalleryIcon
        iconSize={16}
        photosCount={medias.length}
        className={styles.galleryIcon}
        onClick={onOpenDetail}
      />
    </div>
  );
}

export default MobileView;
